import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import ConstantsUtil from '../../context/constantsUtil'
import PedidoCompraService from '../../app/service/estoque/pedidoCompraService'
import HandleErrorService from '../../app/service/handleErrorService'
import GeneralServices from '../../app/service/generalServices'
import TableFilters from '../tableFilters'
import TooltipButton from '../tooltipButton'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import TransactionByNFTable from '../../views/transactions/transactionByNFTable'
import { ProgressSpinner } from 'primereact/progressspinner'
import NFService from '../../app/service/estoque/NFService'
import { classNames } from 'primereact/utils'
import AuthService from '../../app/service/authService'

const fornecedorComCnpjLabel = "fornecedorComCnpj"
const produtoLabel = "produto"
const precoUnLabel = "precoUn"
const qtdLabel = "qtd"
const precoTotalLabel = "precoTotal"
class PedidosCompraTable extends React.Component {

    constructor(){
        super()
        this.tableFilters = new TableFilters()
        this.dt = React.createRef()
        this.itensDt = React.createRef()
        this.pedidoCompraService = new PedidoCompraService()
        this.nfService = new NFService()
    }

    state = {
        list: [],
        loading: false,

        pedidoToViewItens: null,

        loadingItensTable: false,
        itens: [],

        displayNFsALinkarDialog: false,
        loadingNFsALinkar: false,
        nfsALinkar: [],
        pedidoToViewNFs: {},
    }

    
    componentDidMount(){
        this.search()
    }

    search = () => {
        this.setState({loading: true})
        this.pedidoCompraService.search(this.props.initialDate, this.props.finalDate)
        .then(response => {
            let pedidosTratados =  this.trataResponse(response.data)
            this.setState({list: pedidosTratados})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    trataResponse = pedidos => {

        pedidos.forEach(pedido => {
            
            if(pedido.valorTotal === 0){
                pedido.valorTotal = ''
            }

            pedido.link = this.props.pedidosLinkadosId ? this.props.pedidosLinkadosId.includes(pedido.id) : false
            this.calculateLinkString(pedido)

            pedido[fornecedorComCnpjLabel] = `${pedido.nomeFornecedor} (${pedido.cnpjFornecedor})`

            pedido.numeroNFsLinkadasString = pedido.numeroNFsLinkadasList ? pedido.numeroNFsLinkadasList.join(", ") : null

        })

        let pedidosOrdenados = this.reordenaPedidosLinkados(pedidos)
        return pedidosOrdenados
    }

    buscaNFsPedido = (pedidoToViewNFs) => {

        this.setState({
            loadingNFsALinkar: true,
            pedidoToViewNFs,
            displayNFsALinkarDialog: true
        })

        this.nfService.searchNFsLinkadasPedido(pedidoToViewNFs.id)
        .then(response => {
            // console.log(response.data)
            GeneralServices.trataDadosNF(response.data)
            this.setState({nfsALinkar: response.data})
        })
        .catch(error => {
            // console.log(error)
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loadingNFsALinkar: false})
        })


    }

    viewPedido = (pedidoToViewItens) => {
        this.setState({pedidoToViewItens})
        this.setState({loadingItensTable: true})

        this.pedidoCompraService.viewItens(pedidoToViewItens.id)
        .then(response => {
            this.setState({itens: response.data})
            // console.log(response.data)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loadingItensTable: false})
        })

    }
    
    hideDialog = () => {
        this.setState({pedidoToViewItens: null})
        this.setState({itens: []})

        this.setState({selectedItemDescricao: ''})
        this.setState({selectedItemQuantidade: ''})
        this.setState({selectedItemPrecoUnitario: ''})
        this.setState({selectedItemValorTotal: ''})
        this.setState({selectedItemGramatura: ''})
        this.setState({selectedItemMarca: ''})

    }

    hideNFsALinkarDialog = () => {
        this.setState({
            loadingNFsALinkar: false,
            displayNFsALinkarDialog: false,
            nfsALinkar: [],
            pedidoToViewNFs: {}
        })
    }

    calculateLinkString = (pedido) => {
        pedido.linkString = pedido.link ? "Sim" : "Não"
    }

    reordenaPedidosLinkados = pedidos => {
        // console.log("pedidos inicial: ", pedidos)
        let verificaPedidoLinkado = (pedido, link) => link ? pedido.link : !pedido.link
        let pedidosLinkados = pedidos.filter(pedido => verificaPedidoLinkado(pedido, true))
        let pedidosNaoLinkados = pedidos.filter(pedido => verificaPedidoLinkado(pedido, false))
        // console.log("pedidosLinkados: ", pedidosLinkados)
        // console.log("pedidosNaoLinkados: ", pedidosNaoLinkados)
        pedidos = [...pedidosLinkados, ...pedidosNaoLinkados]
        // console.log("pedidos final: ", pedidos)
        return pedidos
    }

    link = pedido => {
        let pedidosList = this.state.list
        pedidosList.forEach(pedidoItem => {
            if(pedidoItem.id === pedido.id){
                pedido.link = !pedido.link
                this.calculateLinkString(pedido)
            }
        })

        this.setState({list: pedidosList})

        this.props.link(pedidosList)

    }

    rowClass(rowData) {
        return {
            [ConstantsUtil.totaisTableLabel]: rowData.link
        }
    }

    getFilenameToExport = () => {
        const inicioNomeArquivo = 'relatorio_pedidos_de_compra'
        return `${inicioNomeArquivo}_de_${this.props.initialDate}_a_${this.props.finalDate}`
    }

    getListProdutosNaoCancelados = () => {
        let list = [...this.state.list]
        list = list.filter(item => !ConstantsUtil.pedidoCanceladoVmarketList.includes(item.status))
        return list;        
    }

    callExportPDF = () => {

        AuthService.startBlockUi()

        let list = this.getListProdutosNaoCancelados()
        
        // console.log("callExportPDF filtrado: ", list)

        let idsPedidosList = list.map(pedido => pedido.id);
        this.pedidoCompraService.viewItensByPedidoIsLid({idsList: idsPedidosList})
        .then(response => {
            this.exportPDF(response.data)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    exportPDF = (mapItensPedidos) => {
        
        let columns = [
            {header: "Fornecedor", field: fornecedorComCnpjLabel},
            {header: "Produto", field: produtoLabel},
            {header: "Preço Un.", field: precoUnLabel},
            {header: "Quantidade", field: qtdLabel},
            {header: "Preço Total", field: precoTotalLabel},
        ]

        let exportColumns = columns.map(col => ({ title: col.header, dataKey: col.field }))
        this.createPDFFIle(this.getFilenameToExport(), exportColumns, mapItensPedidos)

    }    

    createPDFFIle = (filename, exportColumns, mapItensPedidos) => {

        const empresasLabel = `Empresa: ${AuthService.getEmpresa()}`

        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {

                const doc = new jsPDF.default(0, 0);

                // Adicionar título
                doc.setFontSize(20);
                const titulo = `Relatório de Pedidos de Compra - Bepp`;
                const tituloWidth = doc.getTextWidth(titulo);
                const tituloX = (doc.internal.pageSize.width - tituloWidth) / 2;
                doc.text(titulo, tituloX, 15);  

                const valorEixoX = 10
                let valorEixoY = 30
                doc.setFontSize(12);
                doc.text(empresasLabel, valorEixoX, valorEixoY);
                valorEixoY+=10

                doc.setFontSize(10);
                // console.log(this.state.list)
                
                this.getListProdutosNaoCancelados().forEach(pedidoCompra => {
                    const pageHeight = doc.internal.pageSize.height;

                    let descricaoPedido = `Pedido n° ${pedidoCompra.id}, realizado no dia ${pedidoCompra.dataString.replaceAll("-", "/")}, com previsão de entrega até o dia ${pedidoCompra.dataEntregaString.replaceAll("-", "/")}.`
                    // Se estiver perto do final da página, pula para a próxima, evitando quebras.
                    if (valorEixoY + 30 > pageHeight) {
                        doc.addPage();
                        valorEixoY = 20; // margem superior da nova página
                    }

                    doc.text(descricaoPedido, valorEixoX, valorEixoY);
                    valorEixoY+=5

                    let itensList = mapItensPedidos[pedidoCompra.id]
                    let listToExport = itensList.map(item => {
                        let obj = {
                            [fornecedorComCnpjLabel]: pedidoCompra.fornecedorComCnpj,
                            [produtoLabel]: item.descricao,
                            [precoUnLabel]: GeneralServices.valueBodyTemplateWithCifrao(item.precoUnitario),
                            [qtdLabel]: item.quantidade,
                            [precoTotalLabel]: GeneralServices.valueBodyTemplateWithCifrao(item.valorTotal)
                        }
                        return obj
                    })

                    listToExport.push({
                        [fornecedorComCnpjLabel]: ConstantsUtil.totalTableUpperCaseLabel,
                        [precoTotalLabel]: GeneralServices.valueBodyTemplateWithCifrao(pedidoCompra.valorTotal)                        
                    })

                    // console.log("ExportColumns:", exportColumns);
                    // console.log("Column styles keys:", precoUnLabel, qtdLabel, precoTotalLabel);
                    // console.log();

                    doc.autoTable({
                        startY: valorEixoY,
                        head: [exportColumns.map(col => col.title)],
                        body: listToExport.map(item => exportColumns.map(col => item[col.dataKey])),
                        columnStyles: {
                            2: { halign: 'right', cellWidth: 20 }, //Preço Un.
                            3: { halign: 'right' }, //Quantidade
                            4: { halign: 'right', cellWidth: 25 }, //Preço Total
                        },
                        didParseCell: (data) => {
                            const isLastRow = data.row.index === listToExport.length - 1;
                            if (isLastRow) {
                                data.cell.styles.fillColor = [220, 220, 220]; // cinza claro
                                data.cell.styles.fontStyle = 'bold';
                            }
                        },
                    });

                    valorEixoY = doc.lastAutoTable.finalY;
                    valorEixoY+=10

                })

                doc.save(filename);

            })
        })
    }

    render(){

        const dataFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedData,
            this.state.list,
            "selectedData",
            (name, value) => this.setState({[name]: value}),
            'dataString',
            '100%',
            "Data"
        ) 

        const dataEntregaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDataEntrega,
            this.state.list,
            "selectedDataEntrega",
            (name, value) => this.setState({[name]: value}),
            'dataEntregaString',
            '100%',
            "Entrega"
        ) 

        const numeroFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNumero,
            this.state.list,
            "selectedNumero",
            (name, value) => this.setState({[name]: value}),
            'id',
            '100%',
            "Nº"
        ) 

        const fornecedorFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedFornecedor,
            this.state.list,
            "selectedFornecedor",
            (name, value) => this.setState({[name]: value}),
            fornecedorComCnpjLabel,
            '100%',
            "Fornecedor"
        )

        const statusFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedStatus,
            this.state.list,
            "selectedStatus",
            (name, value) => this.setState({[name]: value}),
            'status',
            '100%',
            "Status"
        )

        const statusProcessamentoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedStatusProcessamento,
            this.state.list,
            "selectedStatusProcessamento",
            (name, value) => this.setState({[name]: value}),
            'statusProcessamento',
            '100%',
            "Status"
        )

        const valorFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedValor,
            this.state.list,
            "selectedValor",
            (name, value) => this.setState({[name]: value}),
            'valorTotal',
            '100%',
            "Valor"
        )

        const nfsLinkadasFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNfsLinkadas,
            this.state.list,
            "selectedNfsLinkadas",
            (name, value) => this.setState({[name]: value}),
            'numeroNFsLinkadasString',
            '100%',
            "N° NF"
        )

        const linkStringFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedLinkString,
            this.state.list,
            "selectedLinkString",
            (name, value) => this.setState({[name]: value}),
            'linkString',
            '100%',
            "Link"
        )

        const descricaoItemFilterElement = this.tableFilters.renderTableFilter(
            this.itensDt,
            this.state.selectedItemDescricao,
            this.state.itens,
            "selectedItemDescricao",
            (name, value) => this.setState({[name]: value}),
            'descricao',
            '100%',
            "Produto"
        )

        const quantidadeItemFilterElement = this.tableFilters.renderTableFilter(
            this.itensDt,
            this.state.selectedItemQuantidade,
            this.state.itens,
            "selectedItemQuantidade",
            (name, value) => this.setState({[name]: value}),
            'quantidade',
            '100%',
            "Quantidade"
        )

        const precoUnitarioItemFilterElement = this.tableFilters.renderTableFilter(
            this.itensDt,
            this.state.selectedItemPrecoUnitario,
            this.state.itens,
            "selectedItemPrecoUnitario",
            (name, value) => this.setState({[name]: value}),
            'precoUnitario',
            '100%',
            "Vr. Unit."
        )

        const valorTotalItemFilterElement = this.tableFilters.renderTableFilter(
            this.itensDt,
            this.state.selectedItemValorTotal,
            this.state.itens,
            "selectedItemValorTotal",
            (name, value) => this.setState({[name]: value}),
            'valorTotal',
            '100%',
            "Vr. Total"
        )

        const gramaturaItemFilterElement = this.tableFilters.renderTableFilter(
            this.itensDt,
            this.state.selectedItemGramatura,
            this.state.itens,
            "selectedItemGramatura",
            (name, value) => this.setState({[name]: value}),
            'gramatura',
            '100%',
            "Gramatura"
        )

        const marcaItemFilterElement = this.tableFilters.renderTableFilter(
            this.itensDt,
            this.state.selectedItemMarca,
            this.state.itens,
            "selectedItemMarca",
            (name, value) => this.setState({[name]: value}),
            'marca',
            '100%',
            "Marca"
        )

        const renderLinkButton = (pedido) => {
            if(this.props.insideDialog){
                return(
                    <TooltipButton
                        tooltip={ `${pedido.link ? "Desassociar" : "Associar"} à Nota Fiscal`}
                        icon={ pedido.link ? "pi pi-undo" : "pi pi-link"}
                        tooltipOptions={{position: 'top'}}
                        className={`p-button-rounded p-mr-2 ${pedido.link ? "p-button-danger" : "p-button-success"} right-button`}
                        // onClick={() => this.buscaNFsPedido(pedido)}
                        onClick={() => this.link(pedido)}
                        // style={ {maxHeight: '30px', maxWidth: '30px'} }
                    />
                )
            }
        }

        const renderLinkadoColumn = () => {
            if(this.props.insideDialog){
                return (
                    <Column
                        header="Linkado"
                        field="linkString"
                        style ={ {width: '40px'} }
                        sortable
                        filter filterElement={linkStringFilterElement}                        
                    />
                )
            }
        }

        const renderNfsLink = rowData => {
            
            const classes = classNames({
                'linkValue': true
            });
            
            return(
                <div
                    style ={ {
                        whiteSpace: 'nowrap', /* Impede que o texto quebre em várias linhas */
                        overflow: 'hidden', /* Esconde qualquer conteúdo que exceda o width da coluna */
                        textOverflow: 'ellipsis', /* Adiciona reticências (...) ao final do texto cortado */
                    } }
                    title={rowData.numeroNFsLinkadasString}
                >
                <a 
                    className={classes}

                    onClick={() => this.buscaNFsPedido(rowData)}
                >
                    {/* {rowData.nfsLinkadas} */}
                    {rowData.numeroNFsLinkadasString}
                </a>
                </div>
            )
        }

        const actionBody = (pedido) => {
            return (
                <div className='centraliza-conteudo-div'>
                    <TooltipButton
                        tooltip="Visualizar Itens"
                        icon="pi pi-eye"
                        onClick={() => this.viewPedido(pedido)}
                        // style={ {maxHeight: '30px', maxWidth: '30px'} }
                    />
                    {renderLinkButton(pedido)}
                </div>
            );
        }

        const renderValorItem = () => {
            return (
                <>
                    <Button
                        label={`Valor: ${GeneralServices.showFormattedIfNotNull(this.state.pedidoToViewItens.valorTotal, true)}`}

                    />                
                </>
            )
        }

        const renderItensDialog = () => {
            if(this.state.pedidoToViewItens){
                return(
                <Dialog
                    header={`Itens do Pedido #${this.state.pedidoToViewItens.id}`}
                    visible
                    modal
                    style={{ width: '90%' }}
                    onHide={this.hideDialog}
                    // footer={renderConfirmationAnotacaoFooter()}
                >
                    <div style={{marginBottom: '1rem'}}>
                        {renderValorItem()}
                    </div>
                        {renderItensTable()}

                    <small className="p-error">{this.state.inputTextoAnotacaoErrorClass ? "Digite o texto da anotação": ""}</small>

                </Dialog>
                )
            }
        }

        const renderItensTable = () => {
            return(
                <DataTable
                    ref={this.itensDt}
                    value={this.state.itens}
                    className="p-datatable-sm small-font"
                    rowHover
                    loading={this.state.loadingItensTable}
                    showGridlines
                    paginator rows={ConstantsUtil.initialTableQuantityOption}
                    paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.state.itens.length)}
                    currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} itens"                    
                >

                <Column header="Produto" field='descricao' filter filterElement={descricaoItemFilterElement} />

                <Column header="Quantidade" field='quantidade' filter filterElement={quantidadeItemFilterElement} />

                <Column header ="Valor Unit." field='precoUnitario' filter filterElement={precoUnitarioItemFilterElement} />

                <Column header ="Valor Total" field='valorTotal' filter filterElement={valorTotalItemFilterElement} />

                <Column header="Gramatura" field='gramatura' filter filterElement={gramaturaItemFilterElement} />

                <Column header="Marca" field='marca' filter filterElement={marcaItemFilterElement} />

                </DataTable>

            )
        }

        const renderNFsALinkarDialog = () => {
            if(this.state.displayNFsALinkarDialog){
                if(this.state.loadingNFsALinkar){
                    return (
                        <Dialog
                            visible
                            onHide={this.hideNFsALinkarDialog}
                        >
                            <ProgressSpinner className='custom-progress-spinner' />
                        </Dialog>
                    )
                }
                else{
                    return (
                        <Dialog
                            header={`NFs linkadas ao Pedido #${this.state.pedidoToViewNFs.id}`}
                            visible={this.state.displayNFsALinkarDialog}
                            modal
                            style={{ width: '95%', height: '95%' }}
                            onHide={this.hideNFsALinkarDialog}
                        >
                            <TransactionByNFTable
                                scrollHeight="400px"
                                list = {this.state.nfsALinkar}
                                startLoadingTable={() => this.setState({loadingNFs: true})}
                                finishLoadingTable={() => this.setState({loadingNFs: false})}
                                loading={this.state.loadingNFsALinkar}
                                simpleView
                                insideNFsPedidoCompraLinkDialog
                            />                             
                        </Dialog>
                    )
                }
            }
        }

        const exportHeader = () => {
            return (
                <React.Fragment>
                    
                    {/* <Button
                        label="Exportar"
                        icon="pi pi-file-excel"
                        className="p-button-success small-font small-button"
                        onClick={this.exportXLSX}
                        tooltip={ConstantsUtil.exportXlsxLabel}
                        tooltipOptions={{position: 'top'}}
                    /> */}

                    <Button
                        label="Exportar"
                        icon="pi pi-file-pdf"
                        className="p-button-danger small-font small-button"
                        onClick={this.callExportPDF}
                        style={{marginLeft: '10px'}}
                        tooltip={ConstantsUtil.exportPdfLabel}
                        tooltipOptions={{position: 'top'}}
                    />
                </React.Fragment>
            )
        }

        const renderStyledStatus = (rowData) => {

            const classes = classNames({
                'deficitValue': ConstantsUtil.pedidoCanceladoVmarketList.includes(rowData.status)
            });
    
            return (
                <div className={classes}>
                    {rowData.status}
                </div>
            );
        }

        return(

            <>
                <div className='card-header'>
                    <div className='row'>
                        <div className='col-md-3'>
                            {exportHeader()}
                        </div>
                    </div>
                </div>

                <DataTable
                    ref={this.dt}
                    value={this.state.list}
                    className="p-datatable-sm small-font"
                    rowHover
                    loading={this.state.loading}
                    scrollable
                    scrollHeight = {this.props.scrollHeight ? this.props.scrollHeight : "300px"}
                    showGridlines
                    rowClassName={this.rowClass}
                    // rowClassName={(rowData) => this.rowClassTransaction(rowData, this.props.product)}
                    emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                    paginator rows={ConstantsUtil.initialTableQuantityOption}
                    paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.state.list.length)}
                    currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} pedidos"
                >

                    <Column
                        header="Número"
                        field="id"
                        body={rowData => `#${rowData.id}`}
                        style ={ {width: '40px'} }
                        sortable
                        filter filterElement={numeroFilterElement}
                    />                
                    
                    <Column
                        header="Data"
                        field="dataString"
                        style ={ {width: '40px'} }
                        sortable sortField='data'
                        filter filterElement={dataFilterElement}
                    />                
                    
                    <Column
                        header="Previsão de Entrega"
                        field="dataEntregaString"
                        style ={ {width: '40px'} }
                        sortable sortField='dataEntrega'
                        filter filterElement={dataEntregaFilterElement}
                    />                

                    <Column
                        header="Fornecedor"
                        field={fornecedorComCnpjLabel}
                        style ={ {width: '100px'} }
                        sortable
                        filter filterElement={fornecedorFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.fornecedorComCnpj, rowIndex)}
                    />

                    <Column
                        header="Stauts"
                        field="status"
                        style ={ {width: '100px'} }
                        sortable
                        filter filterElement={statusFilterElement}
                        body={renderStyledStatus}
                    />

                    {/* <Column
                        header="Status de Processamento"
                        field="statusProcessamento"
                        style ={ {width: '100px'} }
                        sortable
                        filter filterElement={statusProcessamentoFilterElement}
                    /> */}

                    <Column
                        header="Valor"
                        field="valorTotal"
                        body = {rowData => <div className='right-align'> {GeneralServices.showFormattedIfNotNull(rowData.valorTotal, true)} </div> }
                        style ={ {width: '40px'} }
                        sortable
                        filter filterElement={valorFilterElement}
                    />

                    <Column
                        header="NFs Linkadas"
                        field="numeroNFsLinkadasString"
                        body = {renderNfsLink}
                        style ={ {width: '40px'} }
                        sortable
                        filter filterElement={nfsLinkadasFilterElement}
                    />

                    {renderLinkadoColumn()}

                    <Column
                        header="Ações" 
                        body={actionBody} style ={ {width: '50px'} }
                    />
                    {/* body={rowData => <div className='right-align'> {actionBody(rowData)} </div>} style ={ {width: '30px'} }/> */}

                </DataTable>

                {renderItensDialog()}

                {renderNFsALinkarDialog()}

            </>
        )
    }
    

}

export default PedidosCompraTable